import { addDays, startOfToday, subDays } from "date-fns";
import { IconButton, PlainButton } from "@medoma/components/Button/Button";
import CaretLeftIcon from "@medoma/components/icons/CaretLeftIcon";
import type { IHeading } from "@medoma/components/Heading/Heading";
import { Heading } from "@medoma/components/Heading/Heading";
import CaretRightIcon from "@medoma/components/icons/CaretRightIcon";
import styles from "./DaySwitcher.module.scss";
import { dateName } from "@/Utils/DateUtils";
import { SelectedDateContext, useSelectedDate } from "@/Utils/useSelectedDate";
import { useContext } from "react";
import { Trans, useLingui } from "@lingui/react/macro";
import { SelectDatePopover } from "../SelectDatePopover/SelectDatePopover";
import { machineFormat } from "@medoma/models/date-and-time";

export const DaySwitcher = ({ size = "h1" }: Pick<IHeading, "size">) => {
  const { t } = useLingui();
  const selectedDate = useSelectedDate();
  const setContext = useContext(SelectedDateContext)?.setSelectedDate;
  const setSelectedDate = (dateTime: Date) => {
    setContext?.(dateTime);
  };
  const goToPreviousDay = () => setSelectedDate(subDays(selectedDate, 1));
  const goToNextDay = () => setSelectedDate(addDays(selectedDate, 1));
  const goToToday = () => setSelectedDate(startOfToday());

  return (
    <div className={styles.dayToggle}>
      <PlainButton onClick={goToToday}>
        <Trans>Idag</Trans>
      </PlainButton>
      <SelectDatePopover
        key={machineFormat(selectedDate, "yyyy-MM-dd")}
        trigger="icon"
        onDateSelect={setSelectedDate}
        selectedDate={selectedDate}
      />
      <IconButton
        aria-label={t`Visa aktiviteter för föregående dag`}
        onClick={goToPreviousDay}
      >
        <CaretLeftIcon />
      </IconButton>
      <IconButton
        aria-label={t`Visa aktiviteter för nästa dag`}
        onClick={goToNextDay}
      >
        <CaretRightIcon />
      </IconButton>
      <Heading level="h2" size={size} className={styles.currentDate}>
        {dateName(selectedDate)}
      </Heading>
    </div>
  );
};
